module.exports = __webpack_public_path__ + "static/landing-section-pattern-d32ab07f54509e6da0a3f1640a214135.svg";